import React, { useState } from 'react';
//MaterialUI Imports
import { Button, Divider, Grid, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

//Icon Imports
import SaveIcon from '@mui/icons-material/Save';
import MoneyIcon from '@mui/icons-material/Money';

//Third Party Imports
import { useFormik } from 'formik';
import * as Yup from 'yup';

//Project Imports
import useBM5FieldExpenses from 'services/useBM5FieldExpensesService';

const BM5FieldExpenses = (props) => {
    //Constants
    const { onSave, onCancel, selectedBM5FieldExpenses } = props;
    const { addBM5FieldExpenses, updateBM5FieldExpenses } = useBM5FieldExpenses();

    //States
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            id: selectedBM5FieldExpenses.id,
            bm5SalarySlabId: 1,
            unitMin: selectedBM5FieldExpenses.unitMin,
            unitMax: selectedBM5FieldExpenses.unitMax,
            amount: selectedBM5FieldExpenses.amount,
            incentive: selectedBM5FieldExpenses.incentive
        },
        validationSchema: Yup.object({
            unitMin: Yup.number(),
            unitMax: Yup.number(),
            amount: Yup.number(),
            incentive: Yup.number()
        }),
        onSubmit: (values) => {
            console.log(values);
            setLoading(true);
            if (selectedBM5FieldExpenses.id != 0) {
                let data = {
                    bM5SalarySlabId: 1,
                    unitMin: values.unitMin,
                    unitMax: values.unitMax,
                    amount: values.amount,
                    incentive: values.incentive
                };
                updateBM5FieldExpenses(selectedBM5FieldExpenses.id, data)
                    .then((response) => {
                        if (response.status === 200) {
                            onSave();
                            onCancel();
                        } else {
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setLoading(false);
                    });
            } else {
                let data = {
                    bM5SalarySlabId: 1,
                    unitMin: values.unitMin,
                    unitMax: values.unitMax,
                    amount: values.amount,
                    incentive: values.incentive
                };
                addBM5FieldExpenses(data)
                    .then((response) => {
                        console.log(response);
                        if (response.status === 200) {
                            setLoading(false);
                            onSave();
                            onCancel();
                        } else {
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setLoading(false);
                    });
            }
        }
    });
    return (
        <>
            <Grid align="center">
                {selectedBM5FieldExpenses.id === 0 ? (
                    <Stack direction="row" spacing={2} sx={{ marginX: 'auto', alignItems: 'center' }}>
                        <MoneyIcon fontSize="medium" color="primary" />
                        <Typography variant="h4">Add New BM-5 Field Expenses</Typography>
                    </Stack>
                ) : (
                    <Stack direction="row" spacing={2} sx={{ marginX: 'auto', alignItems: 'center' }}>
                        <MoneyIcon fontSize="medium" color="primary" />
                        <Typography variant="h4">Edit BM-5 Field Expenses Details</Typography>
                    </Stack>
                )}
            </Grid>
            <Divider sx={{ marginY: 3 }} />
            <Grid>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item sm={3} xs={12}>
                            <TextField
                                name="unitMin"
                                label="Unit Min"
                                onChange={formik.handleChange}
                                value={formik.values.unitMin}
                                fullWidth
                                error={formik.touched.unitMin && Boolean(formik.errors.unitMin)}
                                helperText={formik.touched.unitMin && formik.errors.unitMin}
                            />
                        </Grid>
                        <Grid item sm={3} xs={12}>
                            <TextField
                                name="unitMax"
                                label="Unit Max"
                                onChange={formik.handleChange}
                                value={formik.values.unitMax}
                                fullWidth
                                error={formik.touched.unitMax && Boolean(formik.errors.unitMax)}
                                helperText={formik.touched.unitMax && formik.errors.unitMax}
                            />
                        </Grid>
                        <Grid item sm={3} xs={12}>
                            <TextField
                                name="amount"
                                label="Amount"
                                onChange={formik.handleChange}
                                value={formik.values.amount}
                                fullWidth
                                error={formik.touched.amount && Boolean(formik.errors.amount)}
                                helperText={formik.touched.amount && formik.errors.amount}
                            />
                        </Grid>
                        <Grid item sm={3} xs={12}>
                            <TextField
                                name="incentive"
                                label="Incentive"
                                onChange={formik.handleChange}
                                value={formik.values.incentive}
                                fullWidth
                                error={formik.touched.incentive && Boolean(formik.errors.incentive)}
                                helperText={formik.touched.incentive && formik.errors.incentive}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ marginY: 3 }} />
                    <Grid>
                        <LoadingButton loading={loading} variant="contained" type="submit" startIcon={<SaveIcon />}>
                            Save
                        </LoadingButton>
                        <Button variant="outlined" sx={{ marginLeft: 2 }} onClick={onCancel}>
                            Cancel
                        </Button>
                    </Grid>
                </form>
            </Grid>
        </>
    );
};

export default BM5FieldExpenses;
